var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOngoingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ongoing_icon",
    transform: "translate(-50 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 26,
    height: 26,
    transform: "translate(50 423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(-3 -74.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape_SHAPE:shapes_01._Basic_Basic_-_Circle_outline_",
    "data-name": "shape [SHAPE:shapes/01. Basic/Basic - Circle outline]",
    d: "M1734.984,423.375a12,12,0,1,1-11.359-11.36A12,12,0,0,1,1734.984,423.375Z",
    transform: "translate(-1657 86.501)",
    fill: "none",
    stroke: "#52555e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M6.123,1.488a1,1,0,0,1,1.729,0L13.1,10.526a1,1,0,0,1-.865,1.5H1.737a1,1,0,0,1-.865-1.5Z",
    transform: "translate(73.775 503.846) rotate(90)",
    fill: "#52555e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingIcon);
export default __webpack_public_path__ + "static/media/ongoing_icon.90e032a0672cf04b463eb779911e6c21.svg";
export { ForwardRef as ReactComponent };